import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Error from 'core/errors/Error';
import PageContent from 'layouts/PageContent';
import AccountForm from 'components/accounts/AccountForm';
import AccountFormSkeleton from 'components/accounts/AccountFormSkeleton';
import AccountProgressIndicatorModal from 'components/accounts/AccountProgressIndicatorModal';

import { editAccount } from 'app/features/accounts/accountSaga';

function EditAccount() {
  const params = useParams();

  const dispatch = useDispatch();

  const {
    data: account,
    isError,
    errorMessage,
    isLoading,
    errorCode
  } = useSelector((state) => state.accounts.edit);

  useEffect(() => {
    dispatch(editAccount(params.accountId));
  }, [params.accountId]);

  if (isError)
    return (
      <Error
        status={errorCode}
        message={errorMessage}
        onRetry={() => dispatch(editAccount(params.accountId))}
      />
    );

  return (
    <PageContent title="Edit Account">
      {isLoading ? <AccountFormSkeleton /> : <AccountForm isAddMode={false} account={account} />}
      <AccountProgressIndicatorModal isAddMode={false} />
    </PageContent>
  );
}

export default EditAccount;